import { Record } from 'immutable';
import { PartyType } from './party-type';

const ContactRecord = Record({
  eventContactId: 0,
  version: 0,
  createDate: null,
  modifiedDate: null,
  partyType: null,
  eventId: null,
  firstName: null,
  lastName: null,
  email: null,
  phone: null,
  fax: null
});

export class Contact extends ContactRecord {
  eventContactId: number;
  version: number;
  createdDate: Date;
  modifiedDate: Date;
  partyType: PartyType;
  eventId: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  fax: number;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/contact.ts